import PropTypes from 'prop-types'

import { mergeOverrides } from 'baseui'
import { Button, SIZE } from 'baseui/button'

import { SDButtonOverrides } from './styled-components'
import { forwardRef } from 'react'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'

// eslint-disable-next-line react/display-name
const SDButton = forwardRef((props, ref) => {
  const isPulse = usePulseScope()

  if (props.hidden) return null

  const newProps = {}
  const newOverrides = mergeOverrides(SDButtonOverrides(props.block, isPulse, props.tone), props.overrides)

  Object.keys(props).forEach(prop => {
    if (prop !== 'block' && prop !== 'tone') {
      newProps[prop] = props[prop]
    }
  })

  return <Button {...newProps} ref={ref} size={props.size ?? SIZE.compact} overrides={newOverrides} />
})

SDButton.propTypes = {
  block: PropTypes.bool,
  size: PropTypes.string,
  overrides: PropTypes.object,
  hidden: PropTypes.bool,
  // PULSE only: 'danger' for a destructive confirmation; ignored outside the Client tab.
  tone: PropTypes.oneOf(['danger']),
}

export default SDButton
